import { render, staticRenderFns } from "./Recruit.vue?vue&type=template&id=2c8a6a1d&scoped=true"
import script from "./Recruit.vue?vue&type=script&lang=ts"
export * from "./Recruit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8a6a1d",
  null
  
)

export default component.exports